<template>
    <div>
        <vs-card>
            <div class="flex items-center">
                <vs-icon color="primary" v-bind="$iconData('icon-mail', 'fi-rr-envelope')"></vs-icon>
                <div class="ml-2">{{popupData.email ? popupData.email : '-'}}</div>
            </div>
        </vs-card>
        <div v-if="popupData.content.length">
            <vs-card v-for="(comment, index) of popupData.content" :key="index">
                <div class="text">{{comment.content}}</div>
                <div class="flex justify-end date">
                    <span>{{comment.changedAt | getDate}}</span>
                    <span class="ml-2">{{comment.changedAt | getTime}}</span>
                </div>
            </vs-card>
        </div>
        <div v-else class="text-center text-2xl">
            {{$t('global.No_data')}}
        </div>
    </div>
</template>

<script>
import {getDate} from '@/utils/mixins'

export default {
    props: ['popupData', 'popupType', 'popupButton'],
    mixins: [getDate],

    mounted() {
        this.$store.commit('UPDATE_LOADER_STATE', false)
    }
}
</script>

<style lang="scss" scoped>
.text {
    font-size: 13px;
}
.date {
    color: gray;
}
</style>
